<template>
  <div class="pretty" :class="classes">
    <input
      :id="inputId"
      class="pretty_checkbox"
      type="checkbox"
      :name="name"
      :value="value"
      :checked="modelValue"
      :disabled="disabled"
      @input="$emit('update:modelValue', Boolean($event.target.checked))"
    />
    <div class="state p-cifra">
      <i
        v-if="esCheckbox"
        class="icon fa fa-check"
      ></i>
      <label class="pretty_checkbox control-label" :class="{ hasError: !!message }">
        <slot></slot>
      </label>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-if="message"
      class="help-block text-danger"
      v-html="message"
    >
    </span>
  </div>
</template>

<script>
import { errorsToMessage } from '../../libs/errors';
/**
 * Este componente es bastante cutre. La idea es que en el value le pasemos
 * true y false y esto sirve tanto para el valor del check como para indicar
 * si está marcado o no.
 * Creo que deberíamos de repensarlo bien...
 */
export default {
  props: {
    // true o false para saber si está marcado o no
    modelValue: { type: Boolean, default: false },
    name: { type: String, default: null },
    // Atributo value que lleva el valor del input. Por ejemplo un id o algo
    value: { type: [String, Boolean, Number], default: null },
    disabled: { type: Boolean, default: false },
    inputId: { type: String, default: null },
    tipo: {
      type: String,
      default: 'checkbox',
      validator: (value) => ['checkbox', 'switch'].includes(value),
    },
    error: { type: [String, Array], default: null },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      message: null,
    };
  },
  computed: {
    classes() {
      let clases = '';
      if (this.tipo === 'switch') {
        clases += ' p-switch p-fill';
      } else {
        clases += ' p-icon';
      }
      return clases;
    },
    esCheckbox() {
      return this.tipo === 'checkbox';
    },
  },
  watch: {
    // Cuando cambia el valor quitamos el error
    modelValue() {
      this.message = null;
    },
    error() {
      this.message = errorsToMessage(this.error);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../assets/stylesheets/cifra/vars/main.scss";

  .hasError {
    :deep() {
      .form-control{
        border-color: $color-danger;
      }
      label {
        color: $color-danger;
      }
    }
  }
</style>
